module.exports = __webpack_public_path__ + "static/media/kr.68586ef8.svg";